import $ from "jquery";
import axios from "axios";

// The global bdjs object
const bdjs = {};

/**
 *  strReplace
 *
 *  Performs a string replace
 *
 *  @param {string} search
 *  @param {string} replace
 *  @param {string} subject
 *  @return {string}
 */

bdjs.strReplace = function (search, replace, subject) {
	return subject.split(search).join(replace);
};

/**
 *  uniqueId
 *
 *  Returns a unique ID
 *
 *  @param	string prefix Optional prefix.
 *  @return	string
 */

let idCounter = 0;
bdjs.uniqueId = function (prefix) {
	const id = ++idCounter + "";
	return prefix ? prefix + id : id;
};

bdjs.isUndefined = function (value) {
	return typeof value == "undefined";
};

/**
*  parseArgs
*
*  Merges together defaults and args much like the WP wp_parse_args function

*  @param {object} args
*  @param {object} defaults
*  @return {object}
*/

bdjs.parseArgs = function (args, defaults) {
	if (typeof args !== "object") args = {};
	if (typeof defaults !== "object") defaults = {};
	return $.extend({}, defaults, args);
};

// Global component storage
bdjs.components = [];

/**
*  registerComponent
*
*  register new bd component.
 
*  @param {object} component
*  @return {void}
*/
bdjs.registerComponent = function (component) {
	bdjs.components.push(component);
};

/**
 *  getComponents
 *
 *  Get all component
 *  @return	object
 */

bdjs.getComponents = function () {
	return bdjs.components;
};

/**
 *  getComponent
 *
 *  Get component by id
 *
 *  @param {string} id
 *  @return {object}
 */

bdjs.getComponent = function (id) {
	let component = null;

	bdjs.components.forEach(function (item, index) {
		if (item.id == id) {
			component = bdjs.components[index];
		}
	});

	return component;
};

/**
 * Make ajax request
 * @return {Promise}
 */
bdjs.makeRequest = function (URL, objData) {
	const request = axios.post;

	const formData = new FormData();

	for (const prop in objData) {
		formData.append(prop, objData[prop]);
	}

	return request(URL, formData, {
		headers: {
			"Content-Type": "multipart/form-data",
		},
	});
};

bdjs.removeItemArray = function (arr, value) {
	const index = arr.indexOf(value);
	if (index > -1) {
		arr.splice(index, 1);
	}

	return arr;
};

bdjs.escapeHtml = function (string) {
	const entityMap = {
		"&": "&amp;",
		"<": "&lt;",
		">": "&gt;",
		'"': "&quot;",
		"'": "&#39;",
		"/": "&#x2F;",
		"`": "&#x60;",
		"=": "&#x3D;",
	};

	return String(string).replace(/[&<>"'`=/]/g, function (s) {
		// eslint-disable-line no-useless-escape
		return entityMap[s];
	});
};

bdjs.isArray = function (any) {
	// // Only implement if no native implementation is available
	// if (typeof Array.isArray === "undefined") {
	//     Array.isArray = function (obj) {
	//         return Object.prototype.toString.call(obj) === "[object Array]";
	//     };
	// }
	return Array.isArray(any);
};

/**
 * Split array into multiple parts / chunks
 *
 * @template T
 * @param {Array<T>} arr
 * @param {number} [bulkSize]
 * @returns {Array<Array<T>>}
 *
 * @example
 * const stuffs = [1, 2, 3, 4, 5, 6];
 * const stuffsChunked = splitArrayToBulks(stuffs, 3);
 * // result [[1, 2, 3], [4, 5, 6]]
 */
bdjs.splitArrayToBulks = function (arr, bulkSize = 20) {
	const bulks = [];
	for (let i = 0; i < Math.ceil(arr.length / bulkSize); i++) {
		bulks.push(arr.slice(i * bulkSize, (i + 1) * bulkSize));
	}
	return bulks;
};

/**
 * @example
 * const object = {
 *  1: { name: "Foo" },
 *  2: { name: "Bar" }
 * };
 * const result = indexedObjectToArray(object);
 * console.log(result);
 * // output: [{ name: "Foo" }, { name: "Bar" }]
 * @param {Object} obj
 */
bdjs.indexedObjectToArray = function (obj) {
	if (!obj) return [];
	if (typeof obj !== "object") return [];
	return Object.keys(obj).map((key) => obj[key]);
};

bdjs.keyLength = function (object) {
	return Object.keys(object).length;
};

bdjs.showLoading = function () {
	return $(".transitionPage").addClass("is-active");
};

bdjs.hideLoading = function () {
	return $(".transitionPage").removeClass("is-active");
};

bdjs.listen = function (eventName, callback) {
	return $(document).on(eventName, callback);
};

bdjs.trigger = function (eventName, data) {
	return $(document).trigger(eventName, { data: data });
};

/**
 * @description ### Returns Go / Lua like responses(data, err)
 * when used with await
 *
 * - Example response [ data, undefined ]
 * - Example response [ undefined, Error ]
 *
 *
 * When used with Promise.all([req1, req2, req3])
 * - Example response [ [data1, data2, data3], undefined ]
 * - Example response [ undefined, Error ]
 *
 *
 * When used with Promise.race([req1, req2, req3])
 * - Example response [ data, undefined ]
 * - Example response [ undefined, Error ]
 *
 * @type {BD_GoAsync}
 */
bdjs.goAsync = async (promise) => {
	try {
		const result = await promise;
		return [result, undefined];
	} catch (e) {
		return [undefined, e || true];
	}
};

export default bdjs;
